<template>
<div v-if="mainStore.showCover" class="relative flex min-h-screen overflow-hidden">

    <div class="w-1/2 cursor-pointer" style="--animate-duration: 0.2s">
        <div :class="{ 'show': show, 'correct': correctCall == 'Traveling', 'big-border': madeCall, 'small-border-left': !madeCall }" class="overflow-hidden curtain right bg-blue-900 bg-opacity-90 w-1/2 border-gray-400">
            <div class="absolute z-[9999] top-[45%] left-[15%] opacity-100 text-left max-w-lg">
                <h1 class="font-extrabold text-transparent leading-[4.5rem] text-[4rem] bg-clip-text bg-gradient-to-r from-gray-300 to-blue-500">NFHS Basketball Rules Book</h1>
                <p class="text-3xl font-medium text-white">2023-24 Edition</p>
            </div>
            <img src="https://host.refreps.com/images/nfhs_basketball_cover2.jpg" :class="{ 'show2': show }" class="bg-clip-content overflow-hidden object-cover translate-y-12 translate-x-[-20px] -mt-[150px] w-full skew-x-[10deg] opacity-10" alt="">

        </div>

    </div>

    <div class="w-1/2 curtain mt-[13rem] left-0 -ml-[8rem]">
        <div class="animate__animated animate__fadeIn" style="--animate-duration: 0.4s">
            <div class="px-6">
                <div class="py-24">
                    <div class="mx-auto max-w-2xl px-6 lg:px-8">
                        <div class="mx-auto max-w-2xl lg:mx-0">
                            <h2 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Welcome to NFHS All Access</h2>
                            <p class="mt-3 text-2xl leading-8 text-gray-600">Powered by <span>RefReps</span></p>
                        </div>
                        <ul role="list" class="mx-auto mt-20 grid w-full grid-cols-3 gap-x-8 gap-y-16 text-center">
                            <li>
                                <button @click="showRuleBook()">
                                    <div class="mx-auto flex justify-center items-center select-none bg-blue-900 border-2 text-white text-xl font-bold p-2 rounded-full shadow h-20 w-20 focus:outline-none focus:shadow-outline">
                                        <font-awesome-icon icon="fa-solid fa-book" class="w-10 h-10" />

                                    </div>
                                    <h3 class="mt-6 text-base font-semibold leading-7 tracking-tight text-gray-900">Rules Book</h3>
                                    <p class="text-sm leading-6 text-gray-600">Study, take notes, watch video, and collaborate!</p>
                                </button>
                            </li>

                            <li>
                                <button @click="doNothing()">
                                    <div class="mx-auto flex justify-center items-center select-none bg-blue-900 border-2 text-white text-xl font-bold p-2 rounded-full shadow h-20 w-20 focus:outline-none focus:shadow-outline">
                                        <font-awesome-icon icon="fa-duotone fa-arrow-up-right-from-square" class="w-10 h-10" />

                                    </div>
                                    <h3 class="mt-6 text-base font-semibold leading-7 tracking-tight text-gray-900">Shortcuts</h3>
                                    <p class="text-sm leading-6 text-gray-600">Instant access to your notes and collections!</p>
                                </button>
                            </li>

                            <li>
                                <button @click="doNothing()">
                                    <div class="mx-auto flex justify-center items-center select-none bg-blue-900 border-2 text-white text-xl font-bold p-2 rounded-full shadow h-20 w-20 focus:outline-none focus:shadow-outline">
                                        <font-awesome-icon icon="fa-regular fa-screen-users" class="w-10 h-10" />

                                    </div>
                                    <h3 class="mt-6 text-base font-semibold leading-7 tracking-tight text-gray-900">Study Group</h3>
                                    <p class="text-sm leading-6 text-gray-600">Chat, study, and learn with fellow officials!</p>
                                </button>
                            </li>

                        </ul>
                    </div>
                </div>

            </div>
        </div>
    </div>

</div>

<RuleVideoPlayer v-if="mainStore.showRuleVideo" />

<div v-if="!mainStore.showCover" class="animate__animated animate__fadeIn animate__slow mt-12 px-12 h-[100vh] pb-24 container overflow-scroll mx-auto">

    <button @click="mainStore.showRuleBookOverlay = false" class="w-full inline-flex justify-start items-center text-lg pr-8">
        <font-awesome-icon icon="fa-duotone fa-arrow-left" class="h-6 w-6 hover:scale-110 translate duration-300 ease-in-out" />
    </button>
    <div>

        <div class="flex flex-col p-2 py-6">

            <div class="flex items-center justify-between mr-2">
                <h2 class="font-bold text-2xl"><a href="#">
                        <img class="w-auto h-12 inline-flex mr-2" src="https://host.refreps.com/images/nfhs.jpg" alt="">
                    </a>{{ mainStore.selectedRulebook.title }}</h2>
                <div class="relative w-96">
                    <font-awesome-icon icon="fa-duotone fa-magnifying-glass" class="absolute text-gray-400 top-2.5 left-4" />
                    <input v-model="mainStore.ruleSearch" type="text" class="bg-white h-[40px] border-1 border-gray-200 focus:ring-black focus:border-black w-full px-12 rounded-lg focus:outline-none hover:cursor-pointer" name="">
                    <span @click="mainStore.ruleSearch = ''" class="absolute top-2 right-5 border-l pl-4">
                        <font-awesome-icon icon="fa-solid fa-xmark" class="text-gray-500 hover:text-green-500 hover:cursor-pointer" />
                    </span>
                </div>

            </div>

        </div>
        <hr>
        <br>

    </div>

    <section>
        <div class="m-auto">
            <!-- <h2 v-if="result.length > 0" class="font-bold text-lg text-black">{{ results }} found</h2> -->
            <div class="grid grid-cols-4 gap-6 md:grid-cols-8 lg:grid-cols-12">
                <div class="col-span-4 lg:col-span-3">
                    <aside class="flex flex-col w-full h-screen overflow-y-auto pr-6 border-r rtl:border-r-0 rtl:border-l dark:bg-gray-900 dark:border-gray-700">

                        <div class="flex flex-col justify-between flex-1 mt-6">
                            <nav class="-mx-3 space-y-6 ">

                                <div v-for="rule in mainStore.selectedRulebook.rules" class="space-y-3 ">
                                    <label class="flex items-center justify-between px-3 text-xs text-gray-500 uppercase dark:text-gray-400">
                                        <span>{{ rule.title }}</span>
                                    </label>

                                    <ul class="pl-6 text-[13px]">
                                        <li v-for="section in rule.sections" :class="section.id == mainStore.currentSectionId ? 'text-red-600' : ''" class="my-2 font-medium">
                                            <a v-if="!section.isEditing" @click.prevent="loadSection(rule, section)" href="#">{{ section.title }}</a>
                                        </li>
                                    </ul>

                                </div>

                            </nav>
                        </div>
                    </aside>
                </div>
                <div class="col-span-9 lg:col-span-9">

                    <div class="flex w-full mt-2.5 justify-end">
                        <button @click="mainStore.showNotes = true" class="text-gray-500 bg-transparent hover:bg-gray-200 hover:text-gray-700 active:bg-gray-600 font-bold uppercase text-xs px-4 py-2 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">
                            <font-awesome-icon icon="fa-duotone fa-pen-to-square" class="h-6 w-6 mx-auto block mb-0.5" />
                            <span class="block text-sm">Add Note</span>
                        </button>
                        <button @click="showDiscussion = true, showAI = false" class="text-gray-500 bg-transparent hover:bg-gray-200 hover:text-gray-700 active:bg-gray-600 font-bold uppercase text-xs px-4 py-2 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">
                            <font-awesome-icon icon="fa-duotone fa-messages" class="h-6 w-6 mx-auto block mb-0.5" />
                            <span class="block text-sm">Start Discussion</span>
                        </button>
                        <button @click="showAI = true, showDiscussion = false" class="text-gray-500 bg-transparent hover:bg-gray-200 hover:text-gray-700 active:bg-gray-600 font-bold uppercase text-xs px-4 py-2 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">
                            <font-awesome-icon icon="fa-duotone fa-regular fa-microchip-ai" class="h-6 w-6 mx-auto block mb-0.5" />
                            <span class="block text-sm">Ask AI</span>
                        </button>
                    </div>

                    <div class="px-8" v-if="mainStore.ruleSearch.length == 0 && !showAI && mainStore.ruleSearch.length == 0 && !showDiscussion">

                        <div class="space-y-12">
                            <div class="border-b border-gray-900/10 pb-12">
                                <h2 class="text-base font-semibold leading-7 text-gray-900 mt-4"><span class="">{{ mainStore.currentSectionTitle }}</span></h2>

                                <div class="mt-4 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                                    <div class="col-span-full">
                                        <p v-html="mainStore.content">

                                        </p>
                                    </div>

                                </div>
                            </div>

                        </div>

                    </div>

                    <div class="px-8" v-show="showAI">

                        <div class="relative w-full my-6">
                            <font-awesome-icon icon="fa-duotone fa-magnifying-glass" class="absolute text-gray-400 top-2.5 left-4" />
                            <input type="text" placeholder="Enter your question here..." class="bg-white h-[40px] border-1 border-gray-200 focus:ring-black focus:border-black w-full px-12 rounded-lg focus:outline-none hover:cursor-pointer" name="">
                            <span @click="startTyping" class="absolute top-2 right-5 border-l pl-4">
                                <font-awesome-icon icon="fa-magnifying-glass" class="text-gray-500 hover:text-green-500 hover:cursor-pointer" />
                            </span>
                        </div>
                        <div class="text-lg w-full" id="typewriter"></div>

                    </div>

                    <div class="px-8" v-show="showDiscussion">

                        <CourseMessages />

                    </div>

                    <div class="px-8" v-if="mainStore.ruleSearch.length > 0 && !showAI && mainStore.ruleSearch.length > 0 && !showDiscussion">

                        <div v-for="rule in filteredRules">
                            <!-- <h2 class="font-bold text-2xl">{{ rule.title }}</h2> -->

                            <div class="" v-if="rule.sections.filter(s => s.content.toLowerCase().includes(mainStore.ruleSearch.toLowerCase())).length != 0">
                                <div class="border-b border-gray-900/10 pb-12">
                                    <h2 class="text-base font-semibold leading-7 text-white mt-4 bg-blue-900 px-4 py-1.5 rounded-sm"><span class="">{{ rule.title }}</span></h2>

                                    <div class="mt-4 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                                        <div class="col-span-full" v-for="result in rule.sections.filter(s => s.content.toLowerCase().includes(mainStore.ruleSearch.toLowerCase()))">
                                            <p class="font-bold text-[18px] text-black">{{ result.title }}</p>
                                            <p v-html="highlightKeyword(result.content)" @click="handleClick">

                                            </p>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </section>

</div>

<div v-show="mainStore.showNotes" class="relative z-[9999]" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
    <!-- Background backdrop, show/hide based on slide-over state. -->
    <div class="fixed inset-0 bg-black bg-opacity-40 animate__animated animate__faster" :class="mainStore.showNotes ? 'animate__fadeIn' : 'animate__fadeOut'"></div>

    <div class="fixed inset-0 overflow-hidden">
        <div class="absolute inset-0 overflow-hidden">
            <div class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">

                <div class="pointer-events-auto w-screen max-w-md animate__animated animate__faster" :class="mainStore.showNotes ? 'animate__fadeInRight' : 'animate__fadeOutRight'">
                    <div class="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
                        <div class="h-0 flex-1 overflow-y-auto">
                            <div class="bg-gray-100 px-4 py-6 sm:px-6">
                                <div class="flex items-center justify-between">
                                    <h2 class="text-base font-semibold leading-6 text-black" id="slide-over-title">New Note</h2>
                                    <div class="ml-3 flex h-7 items-center">
                                        <button @click="mainStore.showNotes = false" type="button" class="rounded-md text-black hover:text-white focus:outline-none focus:ring-2 focus:ring-white">
                                            <span class="sr-only">Close panel</span>
                                            <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                                <div class="mt-1">
                                    <p class="text-sm text-black">You can use this for rules references, thoughts, etc. </p>
                                </div>
                            </div>
                            <div class="flex flex-1 flex-col justify-between">
                                <div class="divide-y divide-gray-200 px-4 sm:px-6">
                                    <div class="space-y-6 pb-5 pt-6">

                                        <div>
                                            <label for="description" class="block text-sm font-medium leading-6 text-gray-900">Note</label>
                                            <div class="mt-2">
                                                <textarea v-model="mainStore.currentNote" name="description" rows="4" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-700 sm:text-sm sm:leading-6"></textarea>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="flex flex-shrink-0 justify-end px-4 py-4">
                            <button @click="mainStore.showNotes = false" type="button" class="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">Cancel</button>
                            <button @click="saveNote()" type="submit" class="ml-4 inline-flex justify-center rounded-md bg-gray-700 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-800">Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapStores
} from "pinia";
import useMainStore from "@/stores/main";

import RuleVideoPlayer from '@/components/Student/NFHS/RuleVideoPlayer.vue'
import CourseMessages from '@/components/Student/Course/CourseMessages.vue'

export default {
    name: "NFHSRulebookStudent",
    data() {
        return {
            currentSectionId: '',
            bookID: '',
            showPreview: false,
            ruleSearch: '',
            fullRulebook: [],
            sections: [],
            results: 0,
            showCover: true,
            madeCall: false,
            show: false,
            showCover: true,
            showAI: false,
            showDiscussion: false,

        }
    },
    computed: {
        ...mapStores(useMainStore),
        filteredRules() {
            return this.mainStore.currentRulebook.rules.filter(rule => {
                return {
                    title: rule.title,
                    sections: rule.sections.filter(section => {
                        return section.content.toLowerCase().includes(this.mainStore.ruleSearch.toLowerCase()) || section.title.toLowerCase().includes(this.mainStore.ruleSearch.toLowerCase());
                    })
                }
            });
        },
    },
    components: {
        RuleVideoPlayer,
        CourseMessages
    },
    methods: {
        handleClick(event) {
            if (event.target.id === 'myButton') {
                this.loadVideo();
            }
        },
        startTyping() {
            const typewriter = document.getElementById('typewriter');
            let index = 0;
            typewriter.innerHTML = ''

            function type() {

                const text = `<div class="markdown prose w-full break-words dark:prose-invert light"><p>According to the 2023-24 NFHS Basketball Rules Book, the rules regarding contact between players are quite specific:</p><ol><li><p><strong>General Contact Rules</strong>: A player is not allowed to hold, push, charge, trip, or impede the progress of an opponent by extending their arms, shoulders, hips, or knees, or by bending their body in an unnatural way. Rough tactics are also prohibited. This rule aims to ensure fair play and prevent aggressive or dangerous behavior on the court​<span class="" data-state="closed"></span>​.</p></li><li><p><strong>Contact with Hands</strong>: Contact with an opponent using hands is only permitted if it's incidental and involves the opponent's hand while it is on the ball. This rule is in place to prevent players from using their hands in a way that unfairly restricts the movement or freedom of their opponents​<span class="" data-state="closed"></span>​.</p></li><li><p><strong>Use of Arms and Forearms</strong>: Players are not allowed to extend their arms in a way that hinders an opponent's freedom of movement, except when holding their arms in front of their own face or body for protection or to absorb the force of an imminent charge by an opponent. Additionally, a player cannot use their forearm and/or hand to prevent an opponent from attacking the ball during a dribble or a throw for goal​<span class="" data-state="closed"></span>​.</p></li><li><p><strong>Dribbler's Responsibility</strong>: A player dribbling the ball should neither charge into nor contact an opponent in their path, nor should they attempt to dribble between two opponents or between an opponent and a boundary unless there is reasonable space to do so without contact. The rules also state that when a dribbler has sufficiently passed an opponent to have their head and shoulders in advance of that opponent, the greater responsibility for any subsequent contact lies with the opponent. However, a dribbler moving in a straight line may not be crowded out of their path, but they must avoid contact if the opponent legally obtains a defensive position in their path​<span class="" data-state="closed"></span>​.</p></li></ol><p>So, if a player moves into another player with the ball, whether it is a foul or not depends on how these actions align with the above rules. If the movement is aggressive, hinders the freedom of movement of the opponent, or involves prohibited contact, it could be considered a foul. However, each situation must be assessed individually based on the specific circumstances and the judgment of the officials.</p></div>`

                if (index < text.length) {
                    typewriter.innerHTML = text.slice(0, index) + '<span class="blinking-cursor">|</span>';
                    index++;
                    setTimeout(type, Math.random() * 10 + 5);
                } else {
                    typewriter.innerHTML = text.slice(0, index) + '<span class="blinking-cursor">|</span>';
                }
            }
            // start typing
            type();
        },
        showRuleBook() {
            this.mainStore.showCover = false;
            this.mainStore.showingRulebook = true;
        },
        highlightKeyword(originalText) {
            let searchRegex = new RegExp(this.mainStore.ruleSearch.toLowerCase(), 'gi');
            var highlightedText = originalText.replace(searchRegex, match => {
                return `<span class="bg-yellow-300">${match}</span>`;
            });
            return this.linkText(highlightedText);
        },
        linkText(originalText) {
            let searchRegex = new RegExp("A player who catches the ball with both feet on the floor", 'gi');
            var highlightedText = originalText.replace(searchRegex, match => {
                return `<svg class="svg-icon inline-flex" style="width: 2em; height: 2em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M590.3 532.7l-118 88.5c-9.8 7.3-23.6 5.3-31-4.4-2.9-3.8-4.4-8.5-4.4-13.3v-177c0-12.2 9.9-22.1 22.1-22.1 4.8 0 9.4 1.6 13.3 4.4l118 88.5c9.8 7.3 11.8 21.2 4.4 31-1.2 1.6-2.7 3.1-4.4 4.4zM247.5 205.3h530.9c48.9 0 88.5 39.6 88.5 88.5v442.4c0 48.9-39.6 88.5-88.5 88.5H247.5c-48.9 0-88.5-39.6-88.5-88.5V293.8c0-48.9 39.7-88.5 88.5-88.5z m442.4 44.3H336v530.9h353.9V249.6zM203.3 382.3h88.5V249.6h-44.2c-24.4 0-44.2 19.8-44.2 44.2v88.5z m619.3 0v-88.5c0-24.4-19.8-44.2-44.2-44.2h-44.2v132.7h88.4zM203.3 647.7v88.5c0 24.4 19.8 44.2 44.2 44.2h44.2V647.7h-88.4z m0-44.2h88.5v-177h-88.5v177z m619.3 44.2h-88.5v132.7h44.2c24.4 0 44.2-19.8 44.2-44.2v-88.5z m0-44.2v-177h-88.5v177h88.5z"  /></svg><button id="myButton" class="videoLink font-bold underline cursor-pointer">${match}</button>`;
            });
            return highlightedText;
        },
        getSelectedText() {
            this.axios
                .get(`${import.meta.env.VITE_BASE_LINK}/get-nfhs-rulebook`)
                .then((response) => {
                    this.mainStore.rulebooks = response.data.rulebooks;
                    if (this.mainStore.rulebooks.length > 0) {
                        this.mainStore.currentRulebook = this.mainStore.rulebooks[0];
                        this.mainStore.currentSectionTitle = this.mainStore.rulebooks[0]?.rules[0]?.sections[0]?.title;
                        this.bookID = '4BF44F0F-9284-4B8E-9610-23A93C863255';
                        this.mainStore.currentRulebook.rules.forEach(rule => {
                            rule.sections.forEach(section => {
                                section.isEditing = false;
                            });
                        });
                        this.mainStore.currentRulebook = this.mainStore.rulebooks.find(book => book.id == this.bookID);
                        this.fullRulebook = this.mainStore.currentRulebook.rules.map(rule => {
                            return {
                                title: rule.title,
                                sections: rule.sections.map(section => {
                                    return {
                                        title: section.title,
                                        content: section.content
                                    }
                                })
                            }
                        });
                        this.loadSection(this.mainStore.currentRulebook.rules[0], this.mainStore.currentRulebook.rules[0].sections[0]);
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
        },
        loadSection(rule, section) {
            this.showAI = false
            this.showDiscussion = false
            this.mainStore.notes = section.notes;
            this.mainStore.currentRule = rule;
            this.mainStore.currentSection = section;
            this.mainStore.content = section.content;
            if (section.content == '') {
                this.mainStore.content = '<p><br></p>';
            }
            this.mainStore.currentRuleId = rule.id;
            this.mainStore.currentSectionId = section.id;
            this.currentSectionId = section.id;
            this.mainStore.currentSectionId
            this.mainStore.currentSectionTitle = section.title;
            this.mainStore.ruleSearch = '';
        },
        loadRulebook() {
            this.mainStore.currentRulebook = this.mainStore.rulebooks.find(book => book.id == this.bookID);
            this.loadSection(this.mainStore.currentRulebook.rules[0], this.mainStore.currentRulebook.rules[0].sections[0]);
        },
        loadVideo() {
            this.mainStore.isLoadingPreviewVideo = true;
            this.mainStore.ruleVideoURL = 'https://d3sjyulja6yeep.cloudfront.net/video_resources/BB_Travel_1.m4v'
            this.mainStore.videoTitle = 'Traveling Example Video';
            this.mainStore.showRuleVideo = true;
        }

    },
    mounted() {

        this.getSelectedText();
        this.mainStore.showSupportButton = false;
        setTimeout(() => {
            this.show = true;
        }, 300);

    },
    unmounted() {
        this.mainStore.showSupportButton = true;
        this.mainStore.showingRulebook = false;
    }
}
</script>

<style scoped>
#bg-image::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0%;
    left: 0%;
    z-index: -1;
    opacity: 80%;
    overflow: hidden;
    background: url("https://host.refreps.com/images/bg.png");
    /* transform: rotate(-10deg); */
}

.highlight {
    background: yellow;
}

.ql-editor {
    min-height: 400px;
}

.resizable-pane {
    display: flex;
    flex-flow: row wrap;
    align-items: stretch;
}

.pane {
    position: relative;
    display: flex;
    flex: 1;
    flex-flow: column nowrap;
    align-items: flex-start;
}

.pane.resizable {
    flex: none;
}

.resizer {
    cursor: col-resize;
    position: relative;
    width: 4px;
    margin: 0 -2px;
    z-index: 1;
}

.resizer::before {
    content: "";
    display: block;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 1px;
    height: 100%;
    background-color: #eee;
    transition: background-color 250ms, box-shadow 250ms;
}

.resizer:hover::before {
    background-color: blue;
    box-shadow: 0 1px 4px 1px blue;
}

.curtain {
    position: absolute;
    height: 100%;
    width: 56%;
    transition: transform 0.3s ease-in-out;
    overflow: hidden;
}

.curtain2 {
    position: absolute;
    height: 100%;
    width: 100%;
    transition: transform 0.3s ease-in-out;
    overflow: hidden;
}

.curtain::before {
    content: '';
    position: absolute;
    height: 100%;
    width: 0%;
    /* Adjust the width if needed */
    background-color: inherit;
}

.left::before {
    right: -10%;
    /* Adjust position to cover the gap */
    transform: skewX(-10deg);
}

.right::before {
    left: -10%;
    /* Adjust position to cover the gap */
    transform: skewX(-10deg);
}

.left {
    transform: translateX(-100%);
    left: 0;
}

.right {
    transform: translateX(100%);
    right: 0;
}

.show {
    transform: translateX(0);
}

.show.left {
    transform: skewX(-10deg) translateX(-10%);
}

.show.right {
    transform: skewX(-10deg) translateX(10%);
}

.show2.left {
    transform: translateX(-10%);
}

.show2.right {
    transform: translateX(10%);
}

.correct {
    transition: all 0.5s;
    scale: 1.14;
}

.correct-text {
    transition: all 0.5s;
    scale: 0.95;
}

.big-border {
    border-width: 20px;
}

.small-border-left {
    border-color: rgb(217, 75, 75);
    border-left-width: 15px;
}

.small-border-right {
    border-color: rgb(217, 75, 75);
    border-left-width: 15px;
}

.blinking-cursor {
    margin-left: 5px;
    background-color: #fff;
    animation: blink 0.5s infinite;
}

@keyframes blink {

    0%,
    50% {
        opacity: 1;
    }

    50.1%,
    100% {
        opacity: 0;
    }
}
</style>
